import { Paystub as EmployeePaystub } from '@models/payroll/paystub.model';

export class Paystub extends EmployeePaystub {
    protected static _resource = 'payroll/payrolls/:payroll/payStubs';
}
